module.exports = __webpack_public_path__ + "img/Weapon_78.8d7e27d5.png";